import $ from "jquery";

$(document).ready(function () {
  $(".cda-view-button")
    .unbind("click")
    .bind("click", function () {
      $(".cda-view").addClass("active");
    });
  $(".cda-view-close")
    .unbind("click")
    .bind("click", function () {
      $(".cda-view").removeClass("active");
    });
  // CV view
  $(".cv-btn")
    .unbind("click")
    .bind("click", function () {
      $(this).parents(".grid-content").next().addClass("active");
    });
  $(".cv-btn-close")
    .unbind("click")
    .bind("click", function () {
      $(this).parents(".cv-view").removeClass("active");
    });

  // Mobile toggle view
  $(".srg-title-container")
    .unbind("click")
    .bind("click", function () {
      $(this).parent().parent().next().slideToggle();
      $(this).toggleClass("active");
      $(this).prev().toggleClass("active");
    });
});
